var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"scroll-target"}},[_c('vs-tabs',{staticClass:"tab-action-btn-fill-conatiner",model:{value:(_vm.activeTab),callback:function ($$v) {_vm.activeTab=$$v},expression:"activeTab"}},[_c('vs-tab',{attrs:{"label":"Registration"}},[_c('RegistrationTable')],1),_c('vs-tab',{attrs:{"label":"RSVP"}},[_c('RSVPTable')],1)],1)],1)
}
var staticRenderFns = []

export { render, staticRenderFns }